import ContentBox from '~/components/ContentBox';

import AddPlan from './index';

export default function AddPlanSection({ title, user, segment }) {
  return (
    <ContentBox.Group>
      <ContentBox.Section>
        <AddPlan segment={segment} title={title} user={user} />
      </ContentBox.Section>
    </ContentBox.Group>
  );
}
